// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BankDetails_bankDetailsContainer__cZTU5 {
  padding: 20px;
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);
  min-height: 100vh;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
}

.BankDetails_header__wQpPB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.BankDetails_header__wQpPB .BankDetails_headerLeft__Idn1a h1 {
  margin: 0 0 10px 0;
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #0467a0, #ff0000);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.BankDetails_header__wQpPB .BankDetails_headerLeft__Idn1a p {
  margin: 0;
  color: #666;
  font-size: 1.1rem;
  font-weight: 400;
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU {
  display: flex;
  gap: 15px;
  align-items: center;
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_formLinkButton__xaRho {
  background: linear-gradient(135deg, #0467a0, #035a8a);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 10px 20px rgba(4, 103, 160, 0.3);
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_formLinkButton__xaRho:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(4, 103, 160, 0.4);
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_formLinkButton__xaRho:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_addButton__zv3gI {
  background: linear-gradient(135deg, #0467a0, #ff0000);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 10px 20px rgba(4, 103, 160, 0.3);
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_addButton__zv3gI:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(4, 103, 160, 0.4);
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_addButton__zv3gI:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_logoutButton__zEbz2 {
  background: linear-gradient(135deg, #dc3545, #fd7e14);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 10px 20px rgba(220, 53, 69, 0.3);
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_logoutButton__zEbz2:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(220, 53, 69, 0.4);
}
.BankDetails_header__wQpPB .BankDetails_headerRight__DNHzU .BankDetails_logoutButton__zEbz2:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.BankDetails_successMessage__R17ML {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  font-weight: 600;
  box-shadow: 0 10px 20px rgba(40, 167, 69, 0.3);
  animation: BankDetails_slideIn__9N\\+sS 0.5s ease;
}
.BankDetails_successMessage__R17ML .BankDetails_referenceCode__KvRUe {
  margin-top: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  border: 2px dashed rgba(255, 255, 255, 0.5);
}
.BankDetails_successMessage__R17ML .BankDetails_referenceCode__KvRUe strong {
  font-size: 1.2rem;
  display: block;
  margin-bottom: 5px;
}
.BankDetails_successMessage__R17ML .BankDetails_referenceCode__KvRUe p {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

.BankDetails_errorMessage__occmQ {
  background: linear-gradient(135deg, #dc3545, #fd7e14);
  color: white;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  font-weight: 600;
  box-shadow: 0 10px 20px rgba(220, 53, 69, 0.3);
  animation: BankDetails_slideIn__9N\\+sS 0.5s ease;
}

.BankDetails_filtersSection__6KjYa {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterToggleButton__Ts35M {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterToggleButton__Ts35M:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterButtons__rhwjh {
  display: flex;
  gap: 10px;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterButtons__rhwjh .BankDetails_applyButton__2qF4I {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterButtons__rhwjh .BankDetails_applyButton__2qF4I:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(40, 167, 69, 0.3);
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterButtons__rhwjh .BankDetails_clearButton__dTW2H {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersHeader__ZAsJv .BankDetails_filterButtons__rhwjh .BankDetails_clearButton__dTW2H:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(108, 117, 125, 0.3);
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N input, .BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N select {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N input:focus, .BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N input::placeholder, .BankDetails_filtersSection__6KjYa .BankDetails_filtersContainer__CLOIl .BankDetails_filterGroup__UhG\\+N select::placeholder {
  color: #999;
}

.BankDetails_bulkActions__IaHZj {
  background: linear-gradient(135deg, #ffc107, #fd7e14);
  color: white;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 10px 20px rgba(255, 193, 7, 0.3);
  animation: BankDetails_slideIn__9N\\+sS 0.5s ease;
}
.BankDetails_bulkActions__IaHZj span {
  font-weight: 600;
  font-size: 1.1rem;
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o {
  display: flex;
  gap: 15px;
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o .BankDetails_activateButton__KhHQA {
  background: rgba(40, 167, 69, 0.8);
  color: white;
  border: 2px solid rgba(40, 167, 69, 0.3);
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o .BankDetails_activateButton__KhHQA:hover {
  background: rgb(40, 167, 69);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(40, 167, 69, 0.4);
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o .BankDetails_activateButton__KhHQA:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o .BankDetails_deactivateButton__FfIQg {
  background: rgba(220, 53, 69, 0.8);
  color: white;
  border: 2px solid rgba(220, 53, 69, 0.3);
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o .BankDetails_deactivateButton__FfIQg:hover {
  background: rgb(220, 53, 69);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(220, 53, 69, 0.4);
}
.BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o .BankDetails_deactivateButton__FfIQg:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.BankDetails_actionsBar__B11Gf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h {
  display: flex;
  gap: 15px;
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_downloadButton__MsEyb {
  background: linear-gradient(135deg, #28a745, #20c997);
  box-shadow: 0 5px 15px rgba(40, 167, 69, 0.3);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_downloadButton__MsEyb:hover {
  box-shadow: 0 8px 20px rgba(40, 167, 69, 0.4);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_deleteAllButton__tGri6 {
  background: linear-gradient(135deg, #dc3545, #c82333);
  box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_deleteAllButton__tGri6:hover {
  box-shadow: 0 8px 20px rgba(220, 53, 69, 0.4);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_refreshButton__5iHyG {
  background: linear-gradient(135deg, #6f42c1, #5a32a3);
  box-shadow: 0 5px 15px rgba(111, 66, 193, 0.3);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_refreshButton__5iHyG:hover {
  box-shadow: 0 8px 20px rgba(111, 66, 193, 0.4);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_printButton__cgCnI {
  background: linear-gradient(135deg, #17a2b8, #138496);
  box-shadow: 0 5px 15px rgba(23, 162, 184, 0.3);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h button.BankDetails_printButton__cgCnI:hover {
  box-shadow: 0 8px 20px rgba(23, 162, 184, 0.4);
}
.BankDetails_actionsBar__B11Gf .BankDetails_actionsRight__9umUx .BankDetails_itemCount__OhyY- {
  font-weight: 600;
  color: #666;
  font-size: 1rem;
}

.BankDetails_tableContainer__-0q9T {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  box-sizing: border-box;
}
.BankDetails_tableContainer__-0q9T .BankDetails_loading__fYlwk {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  color: #666;
}
.BankDetails_tableContainer__-0q9T .BankDetails_loading__fYlwk .BankDetails_spinner__k7Zp4 {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: BankDetails_spin__MEUB4 1s linear infinite;
  margin-bottom: 20px;
}
.BankDetails_tableContainer__-0q9T .BankDetails_loading__fYlwk p {
  font-size: 1.1rem;
  font-weight: 600;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB thead {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB thead th {
  padding: 20px 15px;
  text-align: left;
  font-weight: 600;
  font-size: 1rem;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB thead th:first-child {
  padding-left: 25px;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB thead th:last-child {
  padding-right: 25px;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB thead th input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr:hover {
  background: rgba(102, 126, 234, 0.05);
  transform: scale(1.01);
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr.BankDetails_editable__-o8SL {
  background: rgba(40, 167, 69, 0.05);
  border-left: 4px solid #28a745;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr td {
  padding: 18px 15px;
  vertical-align: middle;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr td:first-child {
  padding-left: 25px;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr td:last-child {
  padding-right: 25px;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr td input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_referenceCode__KvRUe {
  font-family: "Courier New", monospace;
  font-weight: 700;
  color: #667eea;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_balance__Ya5wD {
  font-weight: 700;
  color: #28a745;
  font-family: "Courier New", monospace;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_statusBadge__q6hEk {
  padding: 6px 12px;
  border-radius: 20px;
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_editableBadge__cKXzb {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_notEditableBadge__e8IuJ {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button {
  width: 35px;
  height: 35px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button.BankDetails_viewButton__BAStO {
  background: linear-gradient(135deg, #17a2b8, #20c997);
  color: white;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button.BankDetails_editButton__1jHY4 {
  background: linear-gradient(135deg, #ffc107, #fd7e14);
  color: white;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button.BankDetails_activateButton__KhHQA {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button.BankDetails_deactivateButton__FfIQg {
  background: linear-gradient(135deg, #dc3545, #fd7e14);
  color: white;
}
.BankDetails_tableContainer__-0q9T .BankDetails_dataTable__1SSdB tbody tr .BankDetails_actions__gJi-H button.BankDetails_deleteButton__SouGa {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
}

.BankDetails_pagination__V\\+l-R {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.BankDetails_pagination__V\\+l-R button {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}
.BankDetails_pagination__V\\+l-R button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}
.BankDetails_pagination__V\\+l-R button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageButton__3cEjR {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageButton__3cEjR:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageButton__3cEjR:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageInfo__LOV23 {
  font-weight: 600;
  color: #666;
  font-size: 1rem;
  padding: 0 15px;
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageNumbers__Xx54B {
  display: flex;
  gap: 8px;
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageNumbers__Xx54B button {
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 0;
}
.BankDetails_pagination__V\\+l-R .BankDetails_pageNumbers__Xx54B button.BankDetails_activePage__fXKkv {
  background: linear-gradient(135deg, #28a745, #20c997);
  transform: scale(1.1);
}

@keyframes BankDetails_slideIn__9N\\+sS {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes BankDetails_spin__MEUB4 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (min-width: 1600px) {
  .BankDetails_bankDetailsContainer__cZTU5 {
    max-width: 1600px;
    margin: 0 auto;
  }
}
@media (max-width: 1400px) {
  .BankDetails_bankDetailsContainer__cZTU5 {
    max-width: 95%;
    margin: 0 auto;
  }
}
@media (max-width: 1200px) {
  .BankDetails_bankDetailsContainer__cZTU5 {
    max-width: 98%;
    padding: 15px;
  }
  .BankDetails_filtersGrid__lTUu7 {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
@media (max-width: 768px) {
  .BankDetails_bankDetailsContainer__cZTU5 {
    max-width: 100%;
    padding: 10px;
    margin: 0 5px;
  }
  .BankDetails_header__wQpPB {
    flex-direction: column;
    gap: 20px;
    text-align: center;
    padding: 20px;
  }
  .BankDetails_header__wQpPB .BankDetails_headerLeft__Idn1a h1 {
    font-size: 2rem;
  }
  .BankDetails_filtersGrid__lTUu7 {
    grid-template-columns: 1fr;
  }
  .BankDetails_actionsBar__B11Gf {
    flex-direction: column;
    gap: 15px;
  }
  .BankDetails_actionsBar__B11Gf .BankDetails_actionsLeft__Yx00h {
    flex-wrap: wrap;
    justify-content: center;
  }
  .BankDetails_dataTable__1SSdB {
    font-size: 0.85rem;
  }
  .BankDetails_dataTable__1SSdB thead th, .BankDetails_dataTable__1SSdB tbody td {
    padding: 12px 8px;
  }
  .BankDetails_dataTable__1SSdB .BankDetails_actions__gJi-H {
    flex-direction: column;
    gap: 5px;
  }
  .BankDetails_dataTable__1SSdB .BankDetails_actions__gJi-H button {
    width: 30px;
    height: 30px;
    font-size: 1rem;
  }
  .BankDetails_bulkActions__IaHZj {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  .BankDetails_bulkActions__IaHZj .BankDetails_bulkButtons__b\\+i4o {
    justify-content: center;
  }
  .BankDetails_groupedDataContainer__4gRDq {
    gap: 16px;
  }
  .BankDetails_groupedItem__LT6WR {
    margin: 0 5px;
  }
  .BankDetails_officeHeader__lBOX7 {
    padding: 15px;
    flex-direction: column;
    gap: 15px;
  }
  .BankDetails_groupActions__1weoS {
    justify-content: center;
  }
  .BankDetails_bankAccountsSection__YMRmI {
    padding: 15px;
  }
  .BankDetails_bankAccountsTable__qZ3xQ {
    font-size: 12px;
  }
  .BankDetails_bankAccountsTable__qZ3xQ th, .BankDetails_bankAccountsTable__qZ3xQ td {
    padding: 8px 6px;
  }
  .BankDetails_filtersContainer__CLOIl {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .BankDetails_filterGroup__UhG\\+N input, .BankDetails_filterGroup__UhG\\+N select {
    padding: 10px 12px;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .BankDetails_bankDetailsContainer__cZTU5 {
    padding: 8px;
    margin: 0 2px;
  }
  .BankDetails_header__wQpPB {
    padding: 15px;
  }
  .BankDetails_header__wQpPB .BankDetails_headerLeft__Idn1a h1 {
    font-size: 1.5rem;
  }
  .BankDetails_filtersSection__6KjYa {
    padding: 15px;
  }
  .BankDetails_actionsBar__B11Gf {
    padding: 15px;
  }
  .BankDetails_dataTable__1SSdB {
    font-size: 0.8rem;
  }
  .BankDetails_dataTable__1SSdB thead th, .BankDetails_dataTable__1SSdB tbody td {
    padding: 8px 5px;
  }
  .BankDetails_pagination__V\\+l-R {
    flex-direction: column;
    gap: 10px;
    padding: 15px;
  }
  .BankDetails_pagination__V\\+l-R .BankDetails_pageNumbers__Xx54B {
    flex-wrap: wrap;
    justify-content: center;
  }
  .BankDetails_groupedDataContainer__4gRDq {
    gap: 12px;
  }
  .BankDetails_groupedItem__LT6WR {
    margin: 0 2px;
  }
  .BankDetails_officeHeader__lBOX7 {
    padding: 12px;
  }
  .BankDetails_bankAccountsSection__YMRmI {
    padding: 12px;
  }
  .BankDetails_bankAccountsTable__qZ3xQ {
    font-size: 11px;
  }
  .BankDetails_bankAccountsTable__qZ3xQ th, .BankDetails_bankAccountsTable__qZ3xQ td {
    padding: 6px 4px;
  }
  .BankDetails_officeField__4d6pH {
    font-size: 12px;
  }
  .BankDetails_officeField__4d6pH strong {
    min-width: 150px;
  }
  .BankDetails_filtersContainer__CLOIl {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .BankDetails_filterGroup__UhG\\+N input, .BankDetails_filterGroup__UhG\\+N select {
    padding: 8px 10px;
    font-size: 0.85rem;
  }
  .BankDetails_headerRight__DNHzU {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
  .BankDetails_headerRight__DNHzU .BankDetails_formLinkButton__xaRho,
  .BankDetails_headerRight__DNHzU .BankDetails_addButton__zv3gI {
    width: 100%;
    justify-content: center;
  }
}
.BankDetails_groupedDataContainer__4gRDq {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.BankDetails_groupedItem__LT6WR {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.BankDetails_officeHeader__lBOX7 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.BankDetails_officeInfo__n6l9b {
  flex: 1 1;
}

.BankDetails_officeInfo__n6l9b h3 {
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 600;
}

.BankDetails_officeDetails__FlLGj {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BankDetails_officeField__4d6pH {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.BankDetails_officeField__4d6pH strong {
  font-weight: 600;
  color: #fff;
  min-width: 200px;
}

.BankDetails_activeStatus__kF5Fa {
  color: #28a745;
  font-weight: 600;
  margin-left: 8px;
}

.BankDetails_inactiveStatus__k7aC0 {
  color: #dc3545;
  font-weight: 600;
  margin-left: 8px;
}

.BankDetails_tokenStatusContainer__aK3L3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.BankDetails_tokenActions__GTgC1 {
  display: flex;
  gap: 4px;
}

.BankDetails_activateTokenButton__8wBhd {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  min-width: 24px;
  height: 24px;
}
.BankDetails_activateTokenButton__8wBhd:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}
.BankDetails_activateTokenButton__8wBhd:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.BankDetails_deactivateTokenButton__Xpl8a {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  min-width: 24px;
  height: 24px;
}
.BankDetails_deactivateTokenButton__Xpl8a:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}
.BankDetails_deactivateTokenButton__Xpl8a:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.BankDetails_groupActions__1weoS {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.BankDetails_groupActions__1weoS button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
}
.BankDetails_groupActions__1weoS button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}
.BankDetails_groupActions__1weoS button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.BankDetails_groupActions__1weoS button.BankDetails_viewButton__BAStO {
  background: linear-gradient(135deg, #17a2b8, #20c997);
  color: white;
}
.BankDetails_groupActions__1weoS button.BankDetails_editButton__1jHY4 {
  background: linear-gradient(135deg, #ffc107, #fd7e14);
  color: white;
}
.BankDetails_groupActions__1weoS button.BankDetails_deleteButton__SouGa {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
}

.BankDetails_bankAccountsSection__YMRmI {
  padding: 20px;
}

.BankDetails_bankAccountsSection__YMRmI h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.BankDetails_bankAccountsTable__qZ3xQ {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.BankDetails_bankAccountsTable__qZ3xQ th, .BankDetails_bankAccountsTable__qZ3xQ td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
}
.BankDetails_bankAccountsTable__qZ3xQ th {
  background: #f8f9fa;
  color: #333;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}
.BankDetails_bankAccountsTable__qZ3xQ td {
  color: #333;
}
.BankDetails_bankAccountsTable__qZ3xQ tr:hover {
  background-color: #f8f9fa;
}
.BankDetails_bankAccountsTable__qZ3xQ tr.BankDetails_editable__-o8SL {
  background-color: #e8f5e8;
}
.BankDetails_bankAccountsTable__qZ3xQ tr.BankDetails_editable__-o8SL:hover {
  background-color: #d4edda;
}

.BankDetails_referenceCodes__FLyeb {
  padding: 16px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  font-size: 14px;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/components/bank-details/BankDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0EAAA;EACA,iBAAA;EACA,4DAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;AACF;AAEI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AAAN;AAGI;EACE,SAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AADN;AAKE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAHJ;AAKI;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;AAHN;AAKM;EACE,2BAAA;EACA,8CAAA;AAHR;AAMM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAJR;AAQI;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;AANN;AAQM;EACE,2BAAA;EACA,8CAAA;AANR;AASM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAPR;AAWI;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;AATN;AAWM;EACE,2BAAA;EACA,8CAAA;AATR;AAYM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAVR;;AAgBA;EACE,qDAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,8CAAA;EACA,gDAAA;AAbF;AAeE;EACE,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,2CAAA;AAbJ;AAeI;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AAbN;AAgBI;EACE,SAAA;EACA,iBAAA;EACA,YAAA;AAdN;;AAmBA;EACE,qDAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,8CAAA;EACA,gDAAA;AAhBF;;AAmBA;EACE,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;AAhBF;AAkBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;AAhBN;AAkBM;EACE,2BAAA;EACA,+CAAA;AAhBR;AAoBI;EACE,aAAA;EACA,SAAA;AAlBN;AAoBM;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBR;AAoBQ;EACE,2BAAA;EACA,6CAAA;AAlBV;AAsBM;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApBR;AAsBQ;EACE,2BAAA;EACA,+CAAA;AApBV;AA0BE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAxBJ;AA2BM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAzBR;AA4BM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AA1BR;AA4BQ;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AA1BV;AA6BQ;EACE,WAAA;AA3BV;;AAoCA;EACE,qDAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8CAAA;EACA,gDAAA;AAjCF;AAmCE;EACE,gBAAA;EACA,iBAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,SAAA;AAlCJ;AAoCI;EACE,kCAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlCN;AAoCM;EACE,4BAAA;EACA,2BAAA;EACA,6CAAA;AAlCR;AAqCM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAnCR;AAuCI;EACE,kCAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArCN;AAuCM;EACE,4BAAA;EACA,2BAAA;EACA,6CAAA;AArCR;AAwCM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAtCR;;AA4CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;AAzCF;AA2CE;EACE,aAAA;EACA,SAAA;AAzCJ;AA2CI;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;AAzCN;AA2CM;EACE,2BAAA;EACA,+CAAA;AAzCR;AA4CM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AA1CR;AA6CM;EACE,qDAAA;EACA,6CAAA;AA3CR;AA6CQ;EACE,6CAAA;AA3CV;AA+CM;EACE,qDAAA;EACA,6CAAA;AA7CR;AA+CQ;EACE,6CAAA;AA7CV;AAiDM;EACE,qDAAA;EACA,8CAAA;AA/CR;AAiDQ;EACE,8CAAA;AA/CV;AAmDM;EACE,qDAAA;EACA,8CAAA;AAjDR;AAmDQ;EACE,8CAAA;AAjDV;AAwDI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAtDN;;AA2DE;EACE,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,0CAAA;EACA,WAAA;EACA,sBAAA;AAxDJ;AA0DE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAxDJ;AA0DI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,qDAAA;EACA,mBAAA;AAxDN;AA2DI;EACE,iBAAA;EACA,gBAAA;AAzDN;AA6DE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AA3DJ;AA6DI;EACE,qDAAA;EACA,YAAA;AA3DN;AA6DM;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;AA3DR;AA6DQ;EACE,kBAAA;AA3DV;AA8DQ;EACE,mBAAA;AA5DV;AA+DQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA7DV;AAmEM;EACE,gCAAA;EACA,yBAAA;AAjER;AAmEQ;EACE,qCAAA;EACA,sBAAA;AAjEV;AAoEQ;EACE,mCAAA;EACA,8BAAA;AAlEV;AAqEQ;EACE,kBAAA;EACA,sBAAA;AAnEV;AAqEU;EACE,kBAAA;AAnEZ;AAsEU;EACE,mBAAA;AApEZ;AAuEU;EACE,WAAA;EACA,YAAA;EACA,eAAA;AArEZ;AAyEQ;EACE,qCAAA;EACA,gBAAA;EACA,cAAA;AAvEV;AA0EQ;EACE,gBAAA;EACA,cAAA;EACA,qCAAA;AAxEV;AA2EQ;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAzEV;AA4EQ;EACE,qDAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA1EV;AA6EQ;EACE,qDAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA3EV;AA8EQ;EACE,aAAA;EACA,QAAA;EACA,2BAAA;AA5EV;AA8EU;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA5EZ;AA8EY;EACE,2BAAA;EACA,yCAAA;AA5Ed;AA+EY;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AA7Ed;AAgFY;EACE,qDAAA;EACA,YAAA;AA9Ed;AAiFY;EACE,qDAAA;EACA,YAAA;AA/Ed;AAkFY;EACE,qDAAA;EACA,YAAA;AAhFd;AAmFY;EACE,qDAAA;EACA,YAAA;AAjFd;AAoFY;EACE,qDAAA;EACA,YAAA;AAlFd;;AA2FA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,0CAAA;EACA,0CAAA;AAxFF;AA0FE;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAxFJ;AA0FI;EACE,2BAAA;EACA,+CAAA;AAxFN;AA2FI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAzFN;AA6FE;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA3FJ;AA6FI;EACE,2BAAA;EACA,+CAAA;AA3FN;AA8FI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AA5FN;AAgGE;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,QAAA;AA/FJ;AAiGI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AA/FN;AAiGM;EACE,qDAAA;EACA,qBAAA;AA/FR;;AAsGA;EACE;IACE,UAAA;IACA,4BAAA;EAnGF;EAqGA;IACE,UAAA;IACA,wBAAA;EAnGF;AACF;AAsGA;EACE;IAAK,uBAAA;EAnGL;EAoGA;IAAO,yBAAA;EAjGP;AACF;AAoGA;EACE;IACE,iBAAA;IACA,cAAA;EAlGF;AACF;AAqGA;EACE;IACE,cAAA;IACA,cAAA;EAnGF;AACF;AAsGA;EACE;IACE,cAAA;IACA,aAAA;EApGF;EAuGA;IACE,2DAAA;EArGF;AACF;AAwGA;EACE;IACE,eAAA;IACA,aAAA;IACA,aAAA;EAtGF;EAyGA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;IACA,aAAA;EAvGF;EAyGE;IACE,eAAA;EAvGJ;EA2GA;IACE,0BAAA;EAzGF;EA4GA;IACE,sBAAA;IACA,SAAA;EA1GF;EA4GE;IACE,eAAA;IACA,uBAAA;EA1GJ;EA8GA;IACE,kBAAA;EA5GF;EA8GE;IACE,iBAAA;EA5GJ;EA+GE;IACE,sBAAA;IACA,QAAA;EA7GJ;EA+GI;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA7GN;EAkHA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EAhHF;EAkHE;IACE,uBAAA;EAhHJ;EAoHA;IACE,SAAA;EAlHF;EAqHA;IACE,aAAA;EAnHF;EAsHA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EApHF;EAuHA;IACE,uBAAA;EArHF;EAwHA;IACE,aAAA;EAtHF;EAyHA;IACE,eAAA;EAvHF;EAyHE;IACE,gBAAA;EAvHJ;EA2HA;IACE,0BAAA;IACA,SAAA;EAzHF;EA6HE;IACE,kBAAA;IACA,iBAAA;EA3HJ;AACF;AA+HA;EACE;IACE,YAAA;IACA,aAAA;EA7HF;EAgIA;IACE,aAAA;EA9HF;EAgIE;IACE,iBAAA;EA9HJ;EAkIA;IACE,aAAA;EAhIF;EAmIA;IACE,aAAA;EAjIF;EAoIA;IACE,iBAAA;EAlIF;EAoIE;IACE,gBAAA;EAlIJ;EAsIA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EApIF;EAsIE;IACE,eAAA;IACA,uBAAA;EApIJ;EAwIA;IACE,SAAA;EAtIF;EAyIA;IACE,aAAA;EAvIF;EA0IA;IACE,aAAA;EAxIF;EA2IA;IACE,aAAA;EAzIF;EA4IA;IACE,eAAA;EA1IF;EA4IE;IACE,gBAAA;EA1IJ;EA8IA;IACE,eAAA;EA5IF;EA8IE;IACE,gBAAA;EA5IJ;EAgJA;IACE,0BAAA;IACA,SAAA;EA9IF;EAkJE;IACE,iBAAA;IACA,kBAAA;EAhJJ;EAoJA;IACE,sBAAA;IACA,SAAA;IACA,WAAA;EAlJF;EAoJE;;IAEE,WAAA;IACA,uBAAA;EAlJJ;AACF;AAuJA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArJF;;AAwJA;EACE,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,yBAAA;AArJF;;AAwJA;EACE,6DAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AArJF;;AAwJA;EACE,SAAA;AArJF;;AAwJA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AArJF;;AAwJA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArJF;;AAwJA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AArJF;;AAwJA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AArJF;;AAwJA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AArJF;;AAwJA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AArJF;;AAwJA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AArJF;;AAwJA;EACE,aAAA;EACA,QAAA;AArJF;;AAwJA;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AArJF;AAuJE;EACE,2BAAA;EACA,4CAAA;AArJJ;AAwJE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAtJJ;;AA0JA;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAvJF;AAyJE;EACE,2BAAA;EACA,4CAAA;AAvJJ;AA0JE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAxJJ;;AA4JA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAzJF;AA2JE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;AAzJJ;AA2JI;EACE,2BAAA;EACA,yCAAA;AAzJN;AA4JI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AA1JN;AA6JI;EACE,qDAAA;EACA,YAAA;AA3JN;AA8JI;EACE,qDAAA;EACA,YAAA;AA5JN;AA+JI;EACE,qDAAA;EACA,YAAA;AA7JN;;AAkKA;EACE,aAAA;AA/JF;;AAkKA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA/JF;;AAkKA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AA/JF;AAiKE;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AA/JJ;AAkKE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AAhKJ;AAmKE;EACE,WAAA;AAjKJ;AAoKE;EACE,yBAAA;AAlKJ;AAqKE;EACE,yBAAA;AAnKJ;AAsKE;EACE,yBAAA;AApKJ;;AAwKA;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;AArKF","sourcesContent":[".bankDetailsContainer {\n  padding: 20px;\n  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);\n  min-height: 100vh;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  max-width: 1400px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n\n  .headerLeft {\n    h1 {\n      margin: 0 0 10px 0;\n      font-size: 2.5rem;\n      font-weight: 700;\n      background: linear-gradient(135deg, #0467a0, #ff0000);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n    }\n\n    p {\n      margin: 0;\n      color: #666;\n      font-size: 1.1rem;\n      font-weight: 400;\n    }\n  }\n\n  .headerRight {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n\n    .formLinkButton {\n      background: linear-gradient(135deg, #0467a0, #035a8a);\n      color: white;\n      border: none;\n      padding: 15px 30px;\n      border-radius: 50px;\n      font-size: 1.1rem;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      box-shadow: 0 10px 20px rgba(4, 103, 160, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 15px 30px rgba(4, 103, 160, 0.4);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n    }\n\n    .addButton {\n      background: linear-gradient(135deg, #0467a0, #ff0000);\n      color: white;\n      border: none;\n      padding: 15px 30px;\n      border-radius: 50px;\n      font-size: 1.1rem;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      box-shadow: 0 10px 20px rgba(4, 103, 160, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 15px 30px rgba(4, 103, 160, 0.4);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n    }\n\n    .logoutButton {\n      background: linear-gradient(135deg, #dc3545, #fd7e14);\n      color: white;\n      border: none;\n      padding: 15px 30px;\n      border-radius: 50px;\n      font-size: 1.1rem;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      box-shadow: 0 10px 20px rgba(220, 53, 69, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 15px 30px rgba(220, 53, 69, 0.4);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n    }\n  }\n}\n\n.successMessage {\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  padding: 20px;\n  border-radius: 15px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  font-weight: 600;\n  box-shadow: 0 10px 20px rgba(40, 167, 69, 0.3);\n  animation: slideIn 0.5s ease;\n\n  .referenceCode {\n    margin-top: 15px;\n    padding: 15px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 10px;\n    border: 2px dashed rgba(255, 255, 255, 0.5);\n\n    strong {\n      font-size: 1.2rem;\n      display: block;\n      margin-bottom: 5px;\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.9rem;\n      opacity: 0.9;\n    }\n  }\n}\n\n.errorMessage {\n  background: linear-gradient(135deg, #dc3545, #fd7e14);\n  color: white;\n  padding: 20px;\n  border-radius: 15px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  font-weight: 600;\n  box-shadow: 0 10px 20px rgba(220, 53, 69, 0.3);\n  animation: slideIn 0.5s ease;\n}\n\n.filtersSection {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  margin-bottom: 25px;\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n\n  .filtersHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .filterToggleButton {\n      background: linear-gradient(135deg, #667eea, #764ba2);\n      color: white;\n      border: none;\n      padding: 12px 25px;\n      border-radius: 25px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n      }\n    }\n\n    .filterButtons {\n      display: flex;\n      gap: 10px;\n\n      .applyButton {\n        background: linear-gradient(135deg, #28a745, #20c997);\n        color: white;\n        border: none;\n        padding: 10px 20px;\n        border-radius: 20px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        display: flex;\n        align-items: center;\n        gap: 5px;\n\n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 5px 15px rgba(40, 167, 69, 0.3);\n        }\n      }\n\n      .clearButton {\n        background: linear-gradient(135deg, #6c757d, #495057);\n        color: white;\n        border: none;\n        padding: 10px 20px;\n        border-radius: 20px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        display: flex;\n        align-items: center;\n        gap: 5px;\n\n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 5px 15px rgba(108, 117, 125, 0.3);\n        }\n      }\n    }\n  }\n\n  .filtersContainer {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n    padding-top: 20px;\n    border-top: 1px solid #e9ecef;\n\n    .filterGroup {\n      label {\n        display: block;\n        margin-bottom: 8px;\n        font-weight: 600;\n        color: #333;\n        font-size: 0.9rem;\n      }\n\n      input, select {\n        width: 100%;\n        padding: 12px 15px;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        font-size: 1rem;\n        transition: all 0.3s ease;\n        background: white;\n\n        &:focus {\n          outline: none;\n          border-color: #667eea;\n          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n        }\n\n        &::placeholder {\n          color: #999;\n        }\n      }\n    }\n  }\n\n\n}\n\n.bulkActions {\n  background: linear-gradient(135deg, #ffc107, #fd7e14);\n  color: white;\n  padding: 20px;\n  border-radius: 15px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 10px 20px rgba(255, 193, 7, 0.3);\n  animation: slideIn 0.5s ease;\n\n  span {\n    font-weight: 600;\n    font-size: 1.1rem;\n  }\n\n  .bulkButtons {\n    display: flex;\n    gap: 15px;\n\n    .activateButton {\n      background: rgba(40, 167, 69, 0.8);\n      color: white;\n      border: 2px solid rgba(40, 167, 69, 0.3);\n      padding: 10px 20px;\n      border-radius: 25px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      &:hover {\n        background: rgba(40, 167, 69, 1);\n        transform: translateY(-2px);\n        box-shadow: 0 5px 15px rgba(40, 167, 69, 0.4);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n    }\n\n    .deactivateButton {\n      background: rgba(220, 53, 69, 0.8);\n      color: white;\n      border: 2px solid rgba(220, 53, 69, 0.3);\n      padding: 10px 20px;\n      border-radius: 25px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      &:hover {\n        background: rgba(220, 53, 69, 1);\n        transform: translateY(-2px);\n        box-shadow: 0 5px 15px rgba(220, 53, 69, 0.4);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n    }\n  }\n}\n\n.actionsBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n\n  .actionsLeft {\n    display: flex;\n    gap: 15px;\n\n    button {\n      background: linear-gradient(135deg, #667eea, #764ba2);\n      color: white;\n      border: none;\n      padding: 12px 25px;\n      border-radius: 25px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n\n      &.downloadButton {\n        background: linear-gradient(135deg, #28a745, #20c997);\n        box-shadow: 0 5px 15px rgba(40, 167, 69, 0.3);\n\n        &:hover {\n          box-shadow: 0 8px 20px rgba(40, 167, 69, 0.4);\n        }\n      }\n\n      &.deleteAllButton {\n        background: linear-gradient(135deg, #dc3545, #c82333);\n        box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);\n\n        &:hover {\n          box-shadow: 0 8px 20px rgba(220, 53, 69, 0.4);\n        }\n      }\n\n      &.refreshButton {\n        background: linear-gradient(135deg, #6f42c1, #5a32a3);\n        box-shadow: 0 5px 15px rgba(111, 66, 193, 0.3);\n\n        &:hover {\n          box-shadow: 0 8px 20px rgba(111, 66, 193, 0.4);\n        }\n      }\n\n      &.printButton {\n        background: linear-gradient(135deg, #17a2b8, #138496);\n        box-shadow: 0 5px 15px rgba(23, 162, 184, 0.3);\n\n        &:hover {\n          box-shadow: 0 8px 20px rgba(23, 162, 184, 0.4);\n        }\n      }\n    }\n  }\n\n  .actionsRight {\n    .itemCount {\n      font-weight: 600;\n      color: #666;\n      font-size: 1rem;\n    }\n  }\n}\n\n  .tableContainer {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 20px;\n    overflow: hidden;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    width: 100%;\n    box-sizing: border-box;\n\n  .loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px;\n    color: #666;\n\n    .spinner {\n      width: 50px;\n      height: 50px;\n      border: 4px solid #f3f3f3;\n      border-top: 4px solid #667eea;\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n      margin-bottom: 20px;\n    }\n\n    p {\n      font-size: 1.1rem;\n      font-weight: 600;\n    }\n  }\n\n  .dataTable {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.95rem;\n\n    thead {\n      background: linear-gradient(135deg, #667eea, #764ba2);\n      color: white;\n\n      th {\n        padding: 20px 15px;\n        text-align: left;\n        font-weight: 600;\n        font-size: 1rem;\n        border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n\n        &:first-child {\n          padding-left: 25px;\n        }\n\n        &:last-child {\n          padding-right: 25px;\n        }\n\n        input[type=\"checkbox\"] {\n          width: 18px;\n          height: 18px;\n          cursor: pointer;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid #f0f0f0;\n        transition: all 0.3s ease;\n\n        &:hover {\n          background: rgba(102, 126, 234, 0.05);\n          transform: scale(1.01);\n        }\n\n        &.editable {\n          background: rgba(40, 167, 69, 0.05);\n          border-left: 4px solid #28a745;\n        }\n\n        td {\n          padding: 18px 15px;\n          vertical-align: middle;\n\n          &:first-child {\n            padding-left: 25px;\n          }\n\n          &:last-child {\n            padding-right: 25px;\n          }\n\n          input[type=\"checkbox\"] {\n            width: 18px;\n            height: 18px;\n            cursor: pointer;\n          }\n        }\n\n        .referenceCode {\n          font-family: 'Courier New', monospace;\n          font-weight: 700;\n          color: #667eea;\n        }\n\n        .balance {\n          font-weight: 700;\n          color: #28a745;\n          font-family: 'Courier New', monospace;\n        }\n\n        .statusBadge {\n          padding: 6px 12px;\n          border-radius: 20px;\n          color: white;\n          font-size: 0.8rem;\n          font-weight: 600;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n        }\n\n        .editableBadge {\n          background: linear-gradient(135deg, #28a745, #20c997);\n          color: white;\n          padding: 6px 12px;\n          border-radius: 20px;\n          font-size: 0.8rem;\n          font-weight: 600;\n        }\n\n        .notEditableBadge {\n          background: linear-gradient(135deg, #6c757d, #495057);\n          color: white;\n          padding: 6px 12px;\n          border-radius: 20px;\n          font-size: 0.8rem;\n          font-weight: 600;\n        }\n\n        .actions {\n          display: flex;\n          gap: 8px;\n          justify-content: flex-start;\n\n          button {\n            width: 35px;\n            height: 35px;\n            border: none;\n            border-radius: 8px;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 1.1rem;\n\n            &:hover {\n              transform: translateY(-2px);\n              box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n            }\n\n            &:disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n              transform: none;\n            }\n\n            &.viewButton {\n              background: linear-gradient(135deg, #17a2b8, #20c997);\n              color: white;\n            }\n\n            &.editButton {\n              background: linear-gradient(135deg, #ffc107, #fd7e14);\n              color: white;\n            }\n\n            &.activateButton {\n              background: linear-gradient(135deg, #28a745, #20c997);\n              color: white;\n            }\n\n            &.deactivateButton {\n              background: linear-gradient(135deg, #dc3545, #fd7e14);\n              color: white;\n            }\n\n            &.deleteButton {\n              background: linear-gradient(135deg, #dc3545, #c82333);\n              color: white;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  padding: 20px;\n  margin-top: 20px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n\n  button {\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 25px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 100px;\n\n    &:hover:not(:disabled) {\n      transform: translateY(-2px);\n      box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      transform: none;\n    }\n  }\n\n  .pageButton {\n    background: linear-gradient(135deg, #667eea, #764ba2);\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 25px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 100px;\n\n    &:hover:not(:disabled) {\n      transform: translateY(-2px);\n      box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      transform: none;\n    }\n  }\n\n  .pageInfo {\n    font-weight: 600;\n    color: #666;\n    font-size: 1rem;\n    padding: 0 15px;\n  }\n\n  .pageNumbers {\n    display: flex;\n    gap: 8px;\n\n    button {\n      min-width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      padding: 0;\n\n      &.activePage {\n        background: linear-gradient(135deg, #28a745, #20c997);\n        transform: scale(1.1);\n      }\n    }\n  }\n}\n\n// Animations\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n// Responsive Design\n@media (min-width: 1600px) {\n  .bankDetailsContainer {\n    max-width: 1600px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 1400px) {\n  .bankDetailsContainer {\n    max-width: 95%;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 1200px) {\n  .bankDetailsContainer {\n    max-width: 98%;\n    padding: 15px;\n  }\n  \n  .filtersGrid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .bankDetailsContainer {\n    max-width: 100%;\n    padding: 10px;\n    margin: 0 5px;\n  }\n\n  .header {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n    padding: 20px;\n\n    .headerLeft h1 {\n      font-size: 2rem;\n    }\n  }\n\n  .filtersGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .actionsBar {\n    flex-direction: column;\n    gap: 15px;\n\n    .actionsLeft {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n  }\n\n  .dataTable {\n    font-size: 0.85rem;\n\n    thead th, tbody td {\n      padding: 12px 8px;\n    }\n\n    .actions {\n      flex-direction: column;\n      gap: 5px;\n\n      button {\n        width: 30px;\n        height: 30px;\n        font-size: 1rem;\n      }\n    }\n  }\n\n  .bulkActions {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n\n    .bulkButtons {\n      justify-content: center;\n    }\n  }\n\n  .groupedDataContainer {\n    gap: 16px;\n  }\n\n  .groupedItem {\n    margin: 0 5px;\n  }\n\n  .officeHeader {\n    padding: 15px;\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .groupActions {\n    justify-content: center;\n  }\n\n  .bankAccountsSection {\n    padding: 15px;\n  }\n\n  .bankAccountsTable {\n    font-size: 12px;\n    \n    th, td {\n      padding: 8px 6px;\n    }\n  }\n\n  .filtersContainer {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .filterGroup {\n    input, select {\n      padding: 10px 12px;\n      font-size: 0.9rem;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .bankDetailsContainer {\n    padding: 8px;\n    margin: 0 2px;\n  }\n\n  .header {\n    padding: 15px;\n\n    .headerLeft h1 {\n      font-size: 1.5rem;\n    }\n  }\n\n  .filtersSection {\n    padding: 15px;\n  }\n\n  .actionsBar {\n    padding: 15px;\n  }\n\n  .dataTable {\n    font-size: 0.8rem;\n\n    thead th, tbody td {\n      padding: 8px 5px;\n    }\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 10px;\n    padding: 15px;\n\n    .pageNumbers {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n  }\n\n  .groupedDataContainer {\n    gap: 12px;\n  }\n\n  .groupedItem {\n    margin: 0 2px;\n  }\n\n  .officeHeader {\n    padding: 12px;\n  }\n\n  .bankAccountsSection {\n    padding: 12px;\n  }\n\n  .bankAccountsTable {\n    font-size: 11px;\n    \n    th, td {\n      padding: 6px 4px;\n    }\n  }\n\n  .officeField {\n    font-size: 12px;\n    \n    strong {\n      min-width: 150px;\n    }\n  }\n\n  .filtersContainer {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .filterGroup {\n    input, select {\n      padding: 8px 10px;\n      font-size: 0.85rem;\n    }\n  }\n\n  .headerRight {\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n\n    .formLinkButton,\n    .addButton {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n}\n\n// Grouped Data Styles\n.groupedDataContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.groupedItem {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  border: 1px solid #e0e0e0;\n}\n\n.officeHeader {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.officeInfo {\n  flex: 1;\n}\n\n.officeInfo h3 {\n  margin: 0 0 16px 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.officeDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.officeField {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.officeField strong {\n  font-weight: 600;\n  color: #fff;\n  min-width: 200px;\n}\n\n.activeStatus {\n  color: #28a745;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.inactiveStatus {\n  color: #dc3545;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.tokenStatusContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.tokenActions {\n  display: flex;\n  gap: 4px;\n}\n\n.activateTokenButton {\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 4px 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  min-width: 24px;\n  height: 24px;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n.deactivateTokenButton {\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 4px 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  min-width: 24px;\n  height: 24px;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n.groupActions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n\n  button {\n    width: 40px;\n    height: 40px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    color: white;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      transform: none;\n    }\n\n    &.viewButton {\n      background: linear-gradient(135deg, #17a2b8, #20c997);\n      color: white;\n    }\n\n    &.editButton {\n      background: linear-gradient(135deg, #ffc107, #fd7e14);\n      color: white;\n    }\n\n    &.deleteButton {\n      background: linear-gradient(135deg, #dc3545, #c82333);\n      color: white;\n    }\n  }\n}\n\n.bankAccountsSection {\n  padding: 20px;\n}\n\n.bankAccountsSection h4 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  text-align: center;\n}\n\n.bankAccountsTable {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  th, td {\n    padding: 10px 12px;\n    text-align: left;\n    border-bottom: 1px solid #e0e0e0;\n    font-size: 13px;\n  }\n\n  th {\n    background: #f8f9fa;\n    color: #333;\n    font-weight: 600;\n    border-bottom: 2px solid #dee2e6;\n  }\n\n  td {\n    color: #333;\n  }\n\n  tr:hover {\n    background-color: #f8f9fa;\n  }\n\n  tr.editable {\n    background-color: #e8f5e8;\n  }\n\n  tr.editable:hover {\n    background-color: #d4edda;\n  }\n}\n\n.referenceCodes {\n  padding: 16px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #e0e0e0;\n  font-size: 14px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bankDetailsContainer": `BankDetails_bankDetailsContainer__cZTU5`,
	"header": `BankDetails_header__wQpPB`,
	"headerLeft": `BankDetails_headerLeft__Idn1a`,
	"headerRight": `BankDetails_headerRight__DNHzU`,
	"formLinkButton": `BankDetails_formLinkButton__xaRho`,
	"addButton": `BankDetails_addButton__zv3gI`,
	"logoutButton": `BankDetails_logoutButton__zEbz2`,
	"successMessage": `BankDetails_successMessage__R17ML`,
	"slideIn": `BankDetails_slideIn__9N+sS`,
	"referenceCode": `BankDetails_referenceCode__KvRUe`,
	"errorMessage": `BankDetails_errorMessage__occmQ`,
	"filtersSection": `BankDetails_filtersSection__6KjYa`,
	"filtersHeader": `BankDetails_filtersHeader__ZAsJv`,
	"filterToggleButton": `BankDetails_filterToggleButton__Ts35M`,
	"filterButtons": `BankDetails_filterButtons__rhwjh`,
	"applyButton": `BankDetails_applyButton__2qF4I`,
	"clearButton": `BankDetails_clearButton__dTW2H`,
	"filtersContainer": `BankDetails_filtersContainer__CLOIl`,
	"filterGroup": `BankDetails_filterGroup__UhG+N`,
	"bulkActions": `BankDetails_bulkActions__IaHZj`,
	"bulkButtons": `BankDetails_bulkButtons__b+i4o`,
	"activateButton": `BankDetails_activateButton__KhHQA`,
	"deactivateButton": `BankDetails_deactivateButton__FfIQg`,
	"actionsBar": `BankDetails_actionsBar__B11Gf`,
	"actionsLeft": `BankDetails_actionsLeft__Yx00h`,
	"downloadButton": `BankDetails_downloadButton__MsEyb`,
	"deleteAllButton": `BankDetails_deleteAllButton__tGri6`,
	"refreshButton": `BankDetails_refreshButton__5iHyG`,
	"printButton": `BankDetails_printButton__cgCnI`,
	"actionsRight": `BankDetails_actionsRight__9umUx`,
	"itemCount": `BankDetails_itemCount__OhyY-`,
	"tableContainer": `BankDetails_tableContainer__-0q9T`,
	"loading": `BankDetails_loading__fYlwk`,
	"spinner": `BankDetails_spinner__k7Zp4`,
	"spin": `BankDetails_spin__MEUB4`,
	"dataTable": `BankDetails_dataTable__1SSdB`,
	"editable": `BankDetails_editable__-o8SL`,
	"balance": `BankDetails_balance__Ya5wD`,
	"statusBadge": `BankDetails_statusBadge__q6hEk`,
	"editableBadge": `BankDetails_editableBadge__cKXzb`,
	"notEditableBadge": `BankDetails_notEditableBadge__e8IuJ`,
	"actions": `BankDetails_actions__gJi-H`,
	"viewButton": `BankDetails_viewButton__BAStO`,
	"editButton": `BankDetails_editButton__1jHY4`,
	"deleteButton": `BankDetails_deleteButton__SouGa`,
	"pagination": `BankDetails_pagination__V+l-R`,
	"pageButton": `BankDetails_pageButton__3cEjR`,
	"pageInfo": `BankDetails_pageInfo__LOV23`,
	"pageNumbers": `BankDetails_pageNumbers__Xx54B`,
	"activePage": `BankDetails_activePage__fXKkv`,
	"filtersGrid": `BankDetails_filtersGrid__lTUu7`,
	"groupedDataContainer": `BankDetails_groupedDataContainer__4gRDq`,
	"groupedItem": `BankDetails_groupedItem__LT6WR`,
	"officeHeader": `BankDetails_officeHeader__lBOX7`,
	"groupActions": `BankDetails_groupActions__1weoS`,
	"bankAccountsSection": `BankDetails_bankAccountsSection__YMRmI`,
	"bankAccountsTable": `BankDetails_bankAccountsTable__qZ3xQ`,
	"officeField": `BankDetails_officeField__4d6pH`,
	"officeInfo": `BankDetails_officeInfo__n6l9b`,
	"officeDetails": `BankDetails_officeDetails__FlLGj`,
	"activeStatus": `BankDetails_activeStatus__kF5Fa`,
	"inactiveStatus": `BankDetails_inactiveStatus__k7aC0`,
	"tokenStatusContainer": `BankDetails_tokenStatusContainer__aK3L3`,
	"tokenActions": `BankDetails_tokenActions__GTgC1`,
	"activateTokenButton": `BankDetails_activateTokenButton__8wBhd`,
	"deactivateTokenButton": `BankDetails_deactivateTokenButton__Xpl8a`,
	"referenceCodes": `BankDetails_referenceCodes__FLyeb`
};
export default ___CSS_LOADER_EXPORT___;
